<template>
  <h2 class="section__title section__title--error">{{ $t('main-page.rejected.back-to-pharmacy.back-to-pharmacy') }}</h2>
</template>

<script>
export default {
  name: 'back-to-pharmacy',
}
</script>
